import { defineMessages } from 'react-intl-next';

export const i18n: {
	confluenceFilterContributorLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterContributorLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterContributorPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	contributor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	contributor: {
		id: 'dynamic-cards-search-page.filters.names.contributor',
		defaultMessage: 'Contributor',
		description: 'Label for filtering by contributor',
	},
	confluenceFilterContributorPlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterContributorLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterContributorLabelUnselected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
